import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'

import { AddToCartButton } from '../../../../Checkout'
import { mapGraphQLProductToProduct } from '../../../../Theme'
import { SectionHeader, ProductCard } from '../../../../UiBlocks'
import { AddToWishlistButton } from '../../../../Wishlist'

import type { Product } from '../../../../UiBlocks'
import type { RelatedProductItem, AutoRelatedProduct } from '../../../types'

interface ProductCarouselProps {
  title: string
  products: (RelatedProductItem | AutoRelatedProduct)[]
  /** Slides visible at once */
  columns: number
}

/** Titled Swiper carousel of product cards, each with its cart and wishlist buttons. */
export function ProductCarousel({ title, products, columns }: ProductCarouselProps) {
  return (
    <div className="relative mt-5">
      <SectionHeader size="lg" as="h2" className="!leading-[50px] pl-10 pr-10 !absolute z-[2] mb-5 w-full">
        {title}
      </SectionHeader>
      <Swiper
        navigation
        modules={[Navigation]}
        slidesPerView={columns}
        spaceBetween={0}
        className="react-slider"
      >
        {products.map((product) => (
          <SwiperSlide
            key={String(product.id)}
            className="bg-cards-bg px-1 py-2"
          >
            <ProductCard
              product={mapGraphQLProductToProduct(product)}
              renderActions={(p: Product) => (
                <>
                  <AddToCartButton sku={p.sku} className="w-4/5 xl:w-full text-sm md:text-base" />
                  <AddToWishlistButton sku={p.sku} />
                </>
              )}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
